import React from "react";


export const ResultMarker = (props) => {
    const { status, purpose } = props;
    return (
        <div className={status === "운동성공" ? "circle-right su" : "circle-right fa"}>
            <div>
                {status}
                <p>{purpose}kcal</p>
            </div>
        </div>
    );
};
